<template>
  <cms-modal unique="view-crew-behaviour" title="View Crew Incident / Behavior" :screen-height="true"
             :size="crewBehaviour.incident_id == 12 ? 'xl' : ''"
  >
    <div class="row">
      <div class="col" style="height: 80vh"
           :class="{'col-12': crewBehaviour.incident_id != 12, 'col-5': crewBehaviour.incident_id == 12}"
      >
        <form @submit.prevent="confirmUpdateCrewIncident">
          <div class="d-flex mb-2">
            <template template v-if="crew.active == 1 || isSystemAdmin">
              <button type="submit" class="btn btn-warning btn-sm btn-xs mr-2 ml-auto" id="edit-crew-incident"
                      style="opacity: .75"
                      v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff"
                      :disabled="incidentAttachment.id"
              >
                <i class="fas fa-edit"></i>
                {{ editable ? 'Update' : 'Edit' }}
              </button>
            </template>
            <button class="btn btn-outline-danger btn-sm btn-xs"
                    v-if="editable"
                    @click="cancelCrewIncidentEdit"
            >
              <i class="fas fa-times"></i>
              Cancel
            </button>
          </div>

          <div class="form-group row mb-0" :class="{'has-error': crewBehaviourErrors.incident_id }">
            <label for="behaviour-type" class="col-sm-4 col-form-label font-weight-bold">Type:</label>
            <div class="col-sm-8 pl-0 text-center">
              <select id="behaviour-type" required
                      class="custom-select custom-select-sm"
                      v-model="crewBehaviour.incident_id"
                      :disabled="!editable"
              >
                <option :value="null">- Select Incident -</option>
                <option v-for="incidentKey in incidentKeys"
                        :key="incidentKey.id"
                        :value="incidentKey.id"
                >{{ incidentKey.name }}
                </option>
              </select>
              <span class="help-block" v-if="crewBehaviourErrors.incident_id !== ''">
                <small><strong>{{ crewBehaviourErrors.incident_id }}</strong></small>
              </span>
            </div>
          </div>

          <div class="form-group row mb-0" :class="{'has-error': crewBehaviourErrors.vessel_id }">
            <label for="new-vessel-id"
                   class="col-sm-4 col-form-label font-weight-bold"
            >Vessel:</label>
            <div class="col-sm-8 pl-0">

              <VesselDropdown
                  id="view-crew-incident-vessel-id"
                  v-model="crewBehaviour.vessel_id"
                  :selections="vesselKeys"
                  identifier="view-crew-incident-vessel"
                  :editable="editable"
                  :other-function="getOtherVesselKeys"
              ></VesselDropdown>

              <span class="help-block" v-if="crewBehaviourErrors.vessel_id !== ''">
                <small><strong>{{ crewBehaviourErrors.vessel_id }}</strong></small>
              </span>
            </div>
          </div>

          <div class="form-group row mb-1">
            <label class="col-sm-4 col-form-label font-weight-bold"
                   for="at-sea"
            >At Sea
            </label>
            <div class="col-sm-8 pl-1">
              <div class="form-check" v-if="editable">
                <input type="checkbox" id="at-sea" aria-label="At Sea"
                       class="form-check-input scale-1-half"
                       v-model="atSea"
                >
              </div>
              <input type="text" v-else readonly
                     class="form-control form-control-xs"
                     :value="crewBehaviour.to_port_id ? 'YES' : 'NO'"
              >
            </div>
          </div>

          <div class="form-group row mb-0" :class="{'has-error': crewBehaviourErrors.port_id }">
            <label for="port-from" class="col-sm-4 col-form-label font-weight-bold">Port From:</label>
            <div class="col-sm-8 pl-0 text-center">
              <select class="custom-select custom-select-sm" id="port-from"
                      v-model="crewBehaviour.port_id"
                      :disabled="!editable"
              >
                <option :value="0">- Select Port -</option>
                <option v-for="fromPortKey in portKeys" :key="fromPortKey.id"
                        :value="fromPortKey.id">{{ fromPortKey.name }}
                </option>
              </select>

              <span class="help-block" v-if="crewBehaviourErrors.port_id !== ''">
                <small><strong>{{ crewBehaviourErrors.port_id }}</strong></small>
              </span>
            </div>
          </div>

          <div class="form-group row mb-0" id="portToDiv" v-if="atSea"
               :class="{'has-error': crewBehaviourErrors.to_port_id }">
            <label for="new-port-to"
                   class="col-sm-4 col-form-label font-weight-bold"
            >Port To:</label>
            <div class="col-sm-8 pl-0 text-center">
              <select class="custom-select custom-select-sm" id="new-port-to"
                      v-model="crewBehaviour.to_port_id"
                      :disabled="!editable"
              >
                <option :value="0">- Select -</option>
                <option v-for="toPortKey in portKeys" :key="toPortKey.id"
                        :value="toPortKey.id">{{ toPortKey.name }}
                </option>
              </select>
              <span class="help-block" v-if="crewBehaviourErrors.to_port_id !== ''">
                <small><strong>{{ crewBehaviourErrors.to_port_id }}</strong></small>
              </span>
            </div>
          </div>

          <div class="form-group row mb-0" :class="{'has-error': crewBehaviourErrors.incident_date }">
            <label for="incident-date"
                   class="col-sm-4 col-form-label font-weight-bold"
            >Date:</label>
            <div class="col-sm-8 pl-0 text-center">
              <template v-if="editable">
                <input type="date" id="incident-date" class="form-control form-control-sm"
                       v-model="crewBehaviour.incident_date"
                >
                <span class="help-block" v-if="crewBehaviourErrors.incident_date !== ''">
                  <small><strong>{{ crewBehaviourErrors.incident_date }}</strong></small>
                </span>
              </template>
              <template v-else>
                <input type="text" readonly :value="crewBehaviour.incident_date | moment('DD MMM YYYY')"
                       class="form-control form-control-sm">
              </template>
            </div>
          </div>

          <div class="form-group row mb-2" :class="{'has-error': crewBehaviourErrors.remarks }">
            <label for="remarks" class="col-sm-4 col-form-label font-weight-bold">Remarks:</label>
            <div class="col-sm-8 pl-0">
              <textarea class="form-control form-control-sm" id="remarks" rows="3"
                        v-model="crewBehaviour.remarks"
                        :readonly="!editable"
                        style="resize: none"
              ></textarea>
              <span class="help-block" v-if="crewBehaviourErrors.remarks !== ''">
                <small><strong>{{ crewBehaviourErrors.remarks }}</strong></small>
              </span>
            </div>
          </div>

          <div class="form-group row mb-0" :class="{'has-error': crewBehaviourErrors.manning_id }">
            <label for="manning-id" class="col-sm-4 col-form-label font-weight-bold"> Manning </label>
            <div class="col-sm-8 pl-0 text-center">
              <select class="custom-select custom-select-sm" id="manning-id"
                      v-model="crewBehaviour.manning_id"
                      :disabled="!editable"
              >
                <option :value="0">- Select Manning -</option>
                <option v-for="manningKey in manningKeys" :key="manningKey.id"
                        :value="manningKey.id">{{ manningKey.alias }}
                </option>
              </select>
              <span class="help-block" v-if="crewBehaviourErrors.manning_id !== ''">
                <small><strong>{{ crewBehaviourErrors.manning_id }}</strong></small>
              </span>
            </div>
          </div>

          <div class="form-group row mb-0" v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff">
            <label for="viewable" class="col-sm-4 col-form-label font-weight-bold">Viewable to <br/> All Manning
            </label>
            <div class="col-sm-4 pt-3">
              <div class="form-check-inline">
                <input type="checkbox" id="viewable" v-model="crewBehaviour.viewable"
                       v-if="editable"
                       class="form-check-input"
                >
              </div>
              <label for="viewable" class="font-weight-bold">
                {{ crewBehaviour.viewable ? 'YES' : 'NO' }}
              </label>
            </div>
          </div>
        </form>

        <div class="form-group row mb-2 py-2 border-top pl-2"
             v-for="(crewIncidentAttachment, index) in crewBehaviour.crewIncidentAttachments"
             :key="crewIncidentAttachment.id"
             :class="{'bg-lightgray': attachmentIndex === index, 'bg-light': attachmentIndex !== index}"
        >

          <template v-if="crew.active == 1 || isSystemAdmin">
            <div class="col col-sm-12 mb-2" v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff">
              <button class="btn btn-outline-danger btn-sm btn-xs float-right py-0"
                      v-if="incidentAttachment.id === crewIncidentAttachment.id"
                      @click="cancelEditAttachment"
                      :disabled="!(incidentAttachment.id === crewIncidentAttachment.id)"
                      :key="'cancel-edit-' + crewIncidentAttachment.id"
              >
                <i class="fas fa-times"></i>
                Cancel
              </button>


              <button class="btn btn-sm btn-xs btn-danger float-right py-0 font-weight-bolder"
                      v-else
                      name="delete-attachment"
                      :key="'delete-attachment-' + crewIncidentAttachment.id"
                      :disabled="editable || (incidentAttachment.id && incidentAttachment.id != crewIncidentAttachment.id)"
                      @click="confirmDeleteIncidentAttachment(crewIncidentAttachment)"
              >
                <span class="fas fa-trash"></span>
                Delete
              </button>

              <button class="btn btn-warning btn-sm btn-xs float-right py-0 mr-2 font-weight-bolder"
                      name="edit-attachment"
                      :id="'edit-attachment-' + crewIncidentAttachment.id"
                      :disabled="editable || (incidentAttachment.id && incidentAttachment.id != crewIncidentAttachment.id)"
                      @click="confirmUpdateIncidentAttachment(crewIncidentAttachment)"
              >
                <i class="fas fa-edit"></i>
                {{ (incidentAttachment.id === crewIncidentAttachment.id) ? 'Update' : 'Edit' }}
              </button>
            </div>
          </template>

          <label :for="'incident-attachment' + crewIncidentAttachment.id"
                 class="col-sm-4 col-form-label font-weight-bold">Attachment {{ index + 1 }}:</label>
          <div class="col-sm-8 pl-0 mb-2">
            <div class="custom-file form-control-sm" v-if="incidentAttachment.id === crewIncidentAttachment.id">
              <input type="file" class="custom-file-input" accept="application/pdf"
                     :id="'incident-attachment-' + crewIncidentAttachment.id"
                     @change="updateFileLabel(crewIncidentAttachment.id)"
              >
              <label class="custom-file-label"
                     :for="'incident-attachment' + crewIncidentAttachment.id"
                     :id="'incident-attachment-label-' + crewIncidentAttachment.id"
              >Choose File</label>
            </div>
            <a type="button" class="text-primary" v-else
               title="View Attachment"
               @click="loadIncidentAttachmentFile(crewIncidentAttachment.id, index)"
            >View Attachment File</a>

          </div>
          <label :for="'attachment-description' + index"
                 class="col-sm-4 col-form-label font-weight-bold">Description:</label>
          <div class="col-sm-8 pl-0 mb-2">
            <textarea class="form-control form-control-sm" :id="'attachment-description' + index" rows="3"
                      v-model="crewIncidentAttachment.description"
                      :readonly="!(incidentAttachment.id === crewIncidentAttachment.id)"
                      placeholder="No Attachment Description"
                      style="resize: none"
            ></textarea>
          </div>

          <label :for="'attachment-updated-by' + index" class="col-sm-4 col-form-label font-weight-bold">Last Updated
            By:</label>
          <div class="col-sm-8 pl-0 mb-2">
            <input type="text" readonly :id="'attachment-updated-by' + index" class="form-control form-control-sm"
                   v-model="crewIncidentAttachment.updatedBy">
          </div>

          <label :for="'attachment-updated-at' + index" class="col-sm-4 col-form-label font-weight-bold">Last Updated
            At:</label>
          <div class="col-sm-8 pl-0">
            <input type="text" readonly :id="'attachment-updated-at' + index" class="form-control form-control-sm"
                   v-model="crewIncidentAttachment.updatedAt">
          </div>

        </div>

        <template template v-if="crew.active == 1 || isSystemAdmin">
          <div class="form-group row mb-2 py-2 pl-2 bg-light border-top" v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff">

            <label for="incident-attachment-new" class="col-sm-4 col-form-label font-weight-bold">New
              Attachment:</label>
            <div class="col-sm-8 pl-0 mb-2">
              <div class="custom-file form-control-sm">
                <input type="file" class="custom-file-input" id="incident-attachment-new" required
                       accept="application/pdf"
                       @change="updateFileLabel('new')"
                >
                <label class="custom-file-label" for="incident-attachment-new" id="incident-attachment-label-new">Choose
                  File</label>
              </div>
            </div>

            <label for="new-attachment-description"
                   class="col-sm-4 col-form-label font-weight-bold">Description:</label>
            <div class="col-sm-8 pl-0 mb-2">
            <textarea class="form-control form-control-sm" id="new-attachment-description" rows="3"
                      v-model="newIncidentAttachment.description"
                      style="resize: none"
            ></textarea>
            </div>

            <div class="col col-sm-6 offset-3">
              <button class="btn btn-outline-primary btn-sm btn-xs float-right py-0 font-weight-bolder"
                      @click="confirmSaveNewIncidentAttachment"
              >
                <i class="fas fa-save"></i>
                Save New Attachment
              </button>
            </div>

          </div>
        </template>

      </div>

      <!--      <div class="col col-7 border-left border-secondary" v-if="crewBehaviour.incident_id == 12">-->
      <!--        <label class="lead font-weight-bolder display-block pb-2">Select VDR Observations Here</label>-->

      <!--        <template v-for="vdrObservationKey in vdrObservationKeys">-->
      <!--          <div class="form-check mb-1 ml-1 row justify-content-around" :key="vdrObservationKey.id"-->
      <!--               v-if="editable || (crewBehaviour.vdrObservations && crewBehaviour.vdrObservations.includes(vdrObservationKey.id))"-->
      <!--          >-->
      <!--            <input class="form-check-input" type="checkbox"-->
      <!--                   v-if="editable"-->
      <!--                   :id="`edit-observation-${vdrObservationKey.id}`"-->
      <!--                   :value="vdrObservationKey.id"-->
      <!--                   v-model="crewBehaviour.vdrObservations"-->
      <!--            >-->
      <!--            <check-box-display v-else :checked="crewBehaviour.vdrObservations && crewBehaviour.vdrObservations.includes(vdrObservationKey.id)" class="mr-2"/>-->
      <!--            <label  class="form-check-label" :for="`edit-observation-${vdrObservationKey.id}`"-->
      <!--                   :class="{'font-weight-bolder': crewBehaviour.vdrObservations && crewBehaviour.vdrObservations.includes(vdrObservationKey.id)}"-->
      <!--            ><span class="mr-3">{{vdrObservationKey.code}}.</span>{{vdrObservationKey.observation }}</label>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--      </div>-->

      <!--      <table  class="table table-hover table-bordered text-small col col-7 border-left" v-if="crewBehaviour.incident_id == 12">-->
      <div class="col col-7 border-left border-secondary" v-if="crewBehaviour.incident_id == 12">
        <label class="lead font-weight-bolder display-block pb-2">Select VDR Observations Here</label>
        <table class="table table-hover table-bordered text-small border-left table-template-1">
          <thead>
          <tr>
            <th></th>
            <th>Code</th>
            <th>Observation</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="vdrObservationKey in vdrObservationKeys">
            <tr v-if="editable || (crewBehaviour.vdrObservations && crewBehaviour.vdrObservations.includes(vdrObservationKey.id))"
                :key="vdrObservationKey.id"
            >
              <td style="height: 3vh;">
                <input type="checkbox"
                       v-if="editable"
                       :id="`edit-observation-${vdrObservationKey.id}`"
                       :value="vdrObservationKey.id"
                       v-model="crewBehaviour.vdrObservations"
                >
                <check-box-display v-else
                                   :checked="crewBehaviour.vdrObservations && crewBehaviour.vdrObservations.includes(vdrObservationKey.id)"
                                   class="mr-2"/>
              </td>
              <td class="text-right">
                {{ vdrObservationKey.code }}
              </td>
              <td>
                {{ vdrObservationKey.observation }}
              </td>

            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </cms-modal>
</template>

<script>
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {gateMixin} from "@/mixins/gateMixin";
import {mapActions, mapGetters} from 'vuex';

import CmsModal from "@/components/elements/CmsModal";
import VesselDropdown from "@/components/elements/VesselDropdown";
import CheckBoxDisplay from "@/components/elements/CheckBoxDisplay";

export default {
  name: "ViewCrewBehaviour",
  mixins: [vueAppMixin, gateMixin],

  components: {
    VesselDropdown,
    CmsModal,
    CheckBoxDisplay
  },

  props: {
    viewCrewBehaviour: {
      type: Object,
      default() {
        return {};
      }
    },
  },

  data() {
    return {
      crewBehaviour: {},
      crewBehaviourErrors: {},
      editable: false,
      atSea: false,
      incidentAttachment: {},
      originalIncidentAttachment: {},
      attachmentIndex: null,
      newIncidentAttachment: {}
    }
  },

  methods: {
    ...mapActions([
      'getOtherVesselKeys',
      'updateCrewIncident',
      'deleteIncidentAttachment',
      'getIncidentAttachmentFile',
      'addCrewIncidentAttachment',
      'updateCrewIncidentAttachment'
    ]),

    async confirmUpdateCrewIncident() {
      if (this.editable) {
        if (await this.confirmUpdate()) {
          let params = {
            crewIncidentId: this.crewBehaviour.id,
            manning_id: this.crewBehaviour.manning_id,
            incident_date: this.crewBehaviour.incident_date,
            incident_id: this.crewBehaviour.incident_id,
            vessel_id: this.crewBehaviour.vessel_id,
            port_id: this.crewBehaviour.port_id,
            to_port_id: this.crewBehaviour.to_port_id,
            remarks: this.crewBehaviour.remarks,
            viewable: this.crewBehaviour.viewable,
          };

          if (this.crewBehaviour.incident_id == 12) {
            params['vdrObservations'] = this.crewBehaviour.vdrObservations;
          }

          let updatedCrewIncident = await this.updateCrewIncident(params);
          if (updatedCrewIncident.errors) {
            this.crewBehaviourErrors = updatedCrewIncident.errors;
          } else {
            this.crewBehaviourErrors = {};
            this.successAlert('Crew Incident Successfully Updated', 'UPDATE');
            document.getElementById('close-view-crew-behaviour').click();
            this.editable = false;
          }
        }
      } else {
        this.editable = true;
      }
    },

    cancelCrewIncidentEdit() {
      this.crewBehaviour = Object.assign({}, this.viewCrewBehaviour);
      this.editable = false;
    },

    cancelEditAttachment() {
      // this.activateButtonElements(true);
      // document.getElementById('edit-crew-incident').disabled = false;
      this.undoEditCrewIncidentAttachment();
      this.incidentAttachment = {};
    },

    undoEditCrewIncidentAttachment() {
      let index = this.crewBehaviour.crewIncidentAttachments.findIndex(crewIncidentAttachment => {
        return crewIncidentAttachment.id === this.incidentAttachment.id;
      });
      this.crewBehaviour.crewIncidentAttachments.splice(index, 1, this.originalIncidentAttachment);
    },

    async confirmDeleteIncidentAttachment(incidentAttachment) {
      if (await this.confirmUpdate()) {
        let params = {
          incidentAttachmentId: incidentAttachment.id,
          crew_incident_id: incidentAttachment.crew_incident_id
        };
        let deletedIncidentAttachment = await this.deleteIncidentAttachment(params);
        if (deletedIncidentAttachment) {
          this.crewBehaviour = Object.assign({}, this.viewCrewBehaviour);
          this.atSea = !!this.viewCrewBehaviour.to_port_id;
          this.successAlert('Crew Incident Attachment Successfully Deleted', 'DELETE');
        } else {
          this.errorAlert('Crew Incident Attachment Failed to Delete', 'DELETE');
        }
      }
    },

    async confirmUpdateIncidentAttachment(crewIncidentAttachment) {
      if (this.incidentAttachment.id === crewIncidentAttachment.id) {
        if (await this.confirmUpdate()) {
          let formData = new FormData();
          formData.append('crewIncidentAttachmentId', crewIncidentAttachment.id);
          formData.append('description', crewIncidentAttachment.description);

          let input = document.getElementById('incident-attachment-' + crewIncidentAttachment.id)
          if (input.files && input.files[0]) {
            let file = input.files[0];
            formData.append('incidentAttachment', file);
          }
          let updatedCrewIncidentAttachment = await this.updateCrewIncidentAttachment(formData);

          if (!updatedCrewIncidentAttachment.errors) {
            this.successAlert('Crew Incident Attachment Successfully Updated', 'UPDATE');
            this.incidentAttachment = {};
            this.originalIncidentAttachment = {};
          }
        }
      } else {
        // this.activateButtonElements(false);
        // document.getElementById('edit-attachment-' + crewIncidentAttachment.id).disabled = false;
        // document.getElementById('edit-crew-incident').disabled = true;
        this.incidentAttachment = crewIncidentAttachment;
        this.originalIncidentAttachment = Object.assign({}, crewIncidentAttachment);

      }
    },

    updateFileLabel(labelIdentifier) {
      let fileInput = document.getElementById('incident-attachment-' + labelIdentifier);
      let labelId = 'incident-attachment-label-' + labelIdentifier;
      let fileLabel = document.getElementById(labelId);
      let labelText = 'Choose File';
      if (fileInput.files && fileInput.files[0]) {
        let file = fileInput.files[0];
        labelText = file.name;
      }
      fileLabel.innerHTML = labelText;
    },

    async loadIncidentAttachmentFile(crewIncidentAttachmentId, attachmentIndex) {
      let params = {
        incidentAttachmentId: crewIncidentAttachmentId
      }
      let crewIncidentAttachmentFile = await this.getIncidentAttachmentFile(params);
      if (crewIncidentAttachmentFile) {
        this.pdfViewer(`ATTACHMENT ${attachmentIndex + 1} FILE`, crewIncidentAttachmentFile);
      }
    },

    async confirmSaveNewIncidentAttachment() {
      if (await this.confirmCreateAlert('Are you sure you want to add this new attachment?')) {
        let formData = new FormData();
        formData.append('crew_incident_id', this.crewBehaviour.id);
        if (this.newIncidentAttachment.description) {
          formData.append('description', this.newIncidentAttachment.description);
        }
        let input = document.getElementById('incident-attachment-new');
        if (input.files && input.files[0]) {
          let file = input.files[0];
          formData.append('incidentAttachment', file);
        }
        let newIncidentAttachment = await this.addCrewIncidentAttachment(formData);
        if (newIncidentAttachment) {
          input.value = null;
          this.successAlert('Crew Incident Attachment Successfully Added', 'CREATE');
          this.newIncidentAttachment = {};
          this.crewBehaviour = Object.assign({}, this.viewCrewBehaviour);
          this.atSea = !!this.viewCrewBehaviour.to_port_id;
          document.getElementById('incident-attachment-label-new').innerHTML = 'Choose File';
        } else {
          this.errorAlert('Crew Incident Attachment Failed to Save', 'CREATE');
        }
      }
    },

  },

  computed: {
    ...mapGetters([
      'incidentKeys',
      'vesselKeys',
      'portKeys',
      'vdrObservationKeys',
      'manningKeys',
    ])
  },

  watch: {
    'viewCrewBehaviour.id'() {
      this.crewBehaviour = Object.assign({}, this.viewCrewBehaviour);
      this.atSea = !!this.viewCrewBehaviour.to_port_id;
      this.editable = false;
    }
  }

}
</script>

<style scoped>

</style>